import {
  ContactedQueryVariables,
  useContactedQuery
} from '../../../shared';

export const useContacted = (variables: ContactedQueryVariables) => {
  const {data: newData, previousData, loading, refetch} = useContactedQuery({
    variables,
    fetchPolicy: 'cache-and-network',
  })

  const data = newData || previousData;

  const clients = data?.contacted.data || [];

  return {clients, loading, total: data?.contacted.totalElements, refetch}
}
